import * as Solr from "../../../3x1010/Solr";
import WidgetToggler from "../abstract/AbstractWidgetToggler";
import VirtualList from "../VirtualList.component.js";

/**
 * SiteHeader's SimpleSearch component
 * */
export default class WidgetSimpleSearch extends WidgetToggler {
  constructor(conf) {
    super(conf);

    this.container = conf?.container;
    this.listCollection = conf?.listCollection;
    this.listFields = conf?.listFields;
    this.textFieldCont = conf?.textFieldCont;
    this.btnSubmit = conf?.btnSubmit;

    // default collection
    // this.collection = "FOTOTECA_coll";
    this.collection = Solr.Schema.getDefaultCollectionName();
    // default schema
    this.schema = new Solr.Schema(this.collection);
    this.collections = this.schema.getCollectionNames(true);
    this.query = null;

    // set default collection
    this.field;
    this.text;
  }

  init() {
    super.init();

    this.initVSCollection();
    this.initVSFields();
    this.initInputText();
  }

  initVSCollection() {
    if (this.query == null) {
      this.query = new Solr.QueryNodeBoolean(this.schema.findFieldByPath("/"));
    }

    const options = [];

    for (let x = 0; x < this.collections.length; x++) {
      options.push({
        id: this.collections[x],
        label: this.collections[x].split("_")[0],
      });
    }

    // Sorta su label
    options.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }

      if (a.label > b.label) {
        return 1;
      }

      return 0;
    });

    this.vSCollection = new VirtualList(this.listCollection, {
      options: options,
      entryHeight: 30,
      valueKey: "id",
      labelKey: "label",
      isSelect: true,
      callback: this.handleSelectEvs.bind(this),
    });
    this.vSCollection.init();
    this.vSCollection.value = this.collection;
    //this.fields = this.schema.getAllFields(Solr.FieldFlags.FLAG_QUERY, 1, false);
  }

  initVSFields(target = false) {
    const deepSearch = JSON.parse(localStorage.getItem("deepSearchPreference")).active;
    this.fields = this.schema.getAllFields(Solr.FieldFlags.FLAG_QUERY, deepSearch ? 1 : 0, false);
    //debugger;

    this.vSFields = new VirtualList(!target ? this.listFields : target, {
      options: this.fields?.map((f) => {
        return {
          value: f._path,
          Label: this.getLabel(f),
        };
      }),
      entryHeight: 30,
      valueKey: "value",
      labelKey: "Label",
      isSelect: true,
      hasSearch: true,
      callback: this.handleSelectEvs.bind(this),
      ctaLabel: "Seleziona un campo...",
      numberOfRows: 8,
    });
    this.vSFields.init();
  }

  getLabel(f) {
    let ret = f._label;
    const props = [];
    if (f.Relation) {
      props.push("relazione");
    } else if (f.Type == Solr.FieldType.ComplexField) {
      props.push("entità");
    } else if (f.Type == Solr.FieldType.StrField) {
      props.push("case sensitive");
    } else if (f.Lookup) {
      props.push("lemmario");
    }
    for (let x = 0; x < props.length; x++) {
      ret += " (" + props[x] + ")";
    }
    return ret;
  }

  toggleVSField() {
    this.vSFields.destroy();
    this.initVSFields();
  }

  initInputText() {
    const input = this.textFieldCont.querySelector("input[type='text']");
    input?.addEventListener("input", (e) => {
      this.text = input.value;
    });
    input?.addEventListener("keydown", (e) => {
      e.key === "Enter" && this.btnSubmit.click();
    });
  }

  handleSelectEvs(e) {
    switch (e.type) {
      case "change":
        // change data in fields select
        if (e.target === this.vSCollection) {
          this.collection = this.vSCollection.value;
          this.schema = new Solr.Schema(this.collection);
          this.fields = this.schema.getAllFields(Solr.FieldFlags.FLAG_QUERY, 1, false);

          this.vSFields.destroy();
          this.listFields.replaceWith(this.listFields);
          this.initVSFields();
        } else if (e.target === this.vSFields) {
          this.field = this.vSFields.value;
        }

        break;
    }
  }
}
